import * as React from 'react'
import { Container } from 'components/Layout'
import Page from 'components/Page'
import PageHeader from 'components/Page/PageHeader'
import { Crumbs } from 'components/BreadCrumbs'
import { RecordingsList } from 'features/Recordings/RecordingsList'

export interface IRecordingsPageProps {
  location: {
    query: {
      page?: string
      serviceId?: string
      ban?: string
      from?: string
    }
  }
}

export class RecordingsPage extends React.Component<IRecordingsPageProps> {
  render() {
    const { location } = this.props
    return (
      <Page layout={{ header: 'app' }} title="Recordings">
        <PageHeader>
          <Crumbs title="Recordings" />
        </PageHeader>
        <Container paddingTop paddingBottom>
          <RecordingsList
            page={parseInt(location.query.page || '1', 10)}
            serviceId={location.query.serviceId}
            ban={location.query.ban}
            from={location.query.from}
          />
        </Container>
      </Page>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/Recordings/Recordings.tsx